import { Download, ExternalLink, FileText, Presentation } from "lucide-react";
import { pdfUrl } from "../lib/api";

export function PublicationCard({ pub, compact = false }) {
  const isConf = pub.pub_type === "conference";
  return (
    <article data-testid={`publication-card-${pub.id}`} className="group grid gap-4 border-b border-slate-200 py-6 transition-colors duration-200 hover:bg-[var(--surface)]/60 md:grid-cols-12 md:px-4">
      <div className="md:col-span-2">
        <div className="font-mono text-2xl font-medium text-[var(--navy)]">{pub.year || "—"}</div>
        <div className="mt-1 inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider text-slate-500">
          {isConf ? <Presentation size={12} /> : <FileText size={12} />} {isConf ? "Conference" : "Journal"}
        </div>
      </div>
      <div className="md:col-span-7">
        <h3 className="text-base font-semibold leading-snug text-[var(--navy)] sm:text-lg">
          {pub.external_url ? <a href={pub.external_url} target="_blank" rel="noreferrer" data-testid="publication-title-link" className="hover:text-[var(--teal)] hover:underline underline-offset-4">{pub.title}</a> : pub.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{pub.citation}</p>
        {pub.contribution && <p className="mt-1.5 text-xs italic text-slate-500">{pub.contribution}</p>}
        {!compact && (
          <div className="mt-3 flex flex-wrap gap-2">
            <span className="rounded-full bg-[var(--teal-soft)]/60 px-2.5 py-0.5 text-[11px] font-medium text-[var(--navy)]">{pub.category}</span>
            {pub.disease_area && pub.disease_area !== "General" && <span className="rounded-full border border-slate-200 px-2.5 py-0.5 text-[11px] font-medium text-slate-600">{pub.disease_area}</span>}
          </div>
        )}
      </div>
      <div className="flex flex-wrap items-start gap-2 md:col-span-3 md:justify-end">
        {pub.has_pdf && (
          <a href={pdfUrl(pub.id)} target="_blank" rel="noreferrer" data-testid="publication-download-btn" className="btn-primary !px-4 !py-2 !text-xs"><Download size={14} /> PDF</a>
        )}
        {pub.external_url && (
          <a href={pub.external_url} target="_blank" rel="noreferrer" data-testid="publication-external-btn" className="btn-outline !px-4 !py-2 !text-xs"><ExternalLink size={14} /> Journal</a>
        )}
        {!pub.has_pdf && !pub.external_url && <span className="text-xs text-slate-400">Citation only</span>}
      </div>
    </article>
  );
}
